/* corex-munequera-cart.js · Archivos de producción y carrito del personalizador de muñequeras.
   Al añadir: un PNG por cara con contenido (96 × 156 mm con sangrado, 300 ppp grabados en el PNG) → Vercel Blob
   (textil/pendiente/<grupo>/<grupo>_<zona>.png, como camisetas: token de corex-kpi-proxy api/textil-upload) y un JPG
   de vista previa por modelo → Cloudinary; luego /cart/add.js con las URLs en properties ocultas (el PNG, con el
   enlace estable api/textil-archivo). El webhook de corex-kpi-proxy (lib/print-files.js) mueve los PNG a
   textil/<nº>/<nº>_munequera_<zonas>.png y la vista previa a munequeras/<modelo>/<nº> en Cloudinary.
   Depende de CorexMunequeraModel, CorexMunequeraDraw y CorexTextilCart (printPng, uploadAll, canvasToBlob, addToCart). */
(function (global) {
  'use strict';

  var M = global.CorexMunequeraModel;
  var D = global.CorexMunequeraDraw;
  var TC = global.CorexTextilCart;
  var CLOUDINARY_URL = 'https://api.cloudinary.com/v1_1/dgkbsb8ro/image/upload';
  var CLOUDINARY_PRESET = 'corex-sublimación';
  var UPLOAD_ATTEMPTS = 2;
  var PREVIEW_SLUG = 'vista-previa';
  var KPI_BASE = 'https://corex-kpi-proxy.vercel.app';
  var LOGO_URL = 'https://res.cloudinary.com/dgkbsb8ro/image/upload/v1780404763/cxhazehbxerx90hfh9zi.png';

  function userError(msg) { return Object.assign(new Error(msg), { userFacing: true }); }

  function uploadOnce(blob, name, publicId, group) {
    var fd = new FormData();
    fd.append('file', blob, name);
    fd.append('upload_preset', CLOUDINARY_PRESET);
    fd.append('public_id', publicId);
    fd.append('tags', 'munequeras,' + group);
    return fetch(CLOUDINARY_URL, { method: 'POST', body: fd }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok || data.error || !data.secure_url) throw new Error((data.error && data.error.message) || 'HTTP ' + res.status);
        return data.secure_url;
      });
    });
  }
  function upload(file, group) {
    var attempt = function (n) {
      return uploadOnce(file.blob, file.name, file.publicId, group).catch(function (err) {
        if (n < UPLOAD_ATTEMPTS) return attempt(n + 1);
        throw userError('No se ha podido subir «' + file.label + '» (' + err.message + '). Revisa tu conexión e inténtalo de nuevo; no se ha añadido nada al carrito.');
      });
    };
    return attempt(1);
  }

  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('imagen')); };
      img.src = url;
    });
  }
  var logoPromise = null;
  function loadLogo() {
    if (!logoPromise) logoPromise = loadImage(LOGO_URL).catch(function () { logoPromise = null; return null; });
    return logoPromise;
  }

  /* JPG de la vista previa: las caras visibles sobre la foto del modelo, con título y logo.
     opts: { design, model: { label, photo, area }, getImage, headFont, bodyFont } */
  function previewJpg(opts) {
    var d = opts.design;
    return loadLogo().then(function (logo) {
      var SCALE = 2, BAND_W = 200, M_ = 44, GAP = 22, HEAD_H = 70, LABEL_H = 30, FOOT_H = 76;
      var photo = opts.model.photo;
      var bandH = Math.round(BAND_W * (photo ? photo.naturalHeight / photo.naturalWidth : 156 / 96));
      var rows = d.caras === 'ambas' ? [false, true] : [false];
      var cols = ['A', 'B'];
      var W = M_ * 2 + BAND_W * cols.length + GAP * (cols.length - 1);
      var H = M_ + HEAD_H + rows.length * (bandH + LABEL_H) + (rows.length - 1) * GAP + FOOT_H;
      var canvas = document.createElement('canvas');
      canvas.width = W * SCALE;
      canvas.height = H * SCALE;
      var ctx = canvas.getContext('2d');
      ctx.scale(SCALE, SCALE);
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = '#141414';
      ctx.textBaseline = 'alphabetic';
      ctx.textAlign = 'left';
      ctx.font = '700 24px ' + opts.headFont;
      ctx.fillText('TUS MUÑEQUERAS COREX', M_, M_ + 22);
      ctx.fillStyle = '#5C5752';
      ctx.font = '14px ' + opts.bodyFont;
      ctx.fillText(opts.model.label + ' · ' + M.MODE_LABEL[d.mode] + ' · ' + M.CARAS_LABEL[d.caras], M_, M_ + 46);
      var tmp = document.createElement('canvas');
      tmp.width = BAND_W * SCALE;
      tmp.height = bandH * SCALE;
      rows.forEach(function (back, ri) {
        var y = M_ + HEAD_H + ri * (bandH + LABEL_H + GAP);
        cols.forEach(function (side, ci) {
          var x = M_ + ci * (BAND_W + GAP);
          var zone = M.ZONES.filter(function (z) { return z.side === side && z.back === back; })[0];
          D.drawPhotoFace(tmp, d.faces[M.faceKeyFor(d.mode, zone)], photo, opts.model.area, opts.getImage);
          ctx.drawImage(tmp, x, y, BAND_W, bandH);
          ctx.fillStyle = '#5C5752';
          ctx.textAlign = 'center';
          ctx.font = '13px ' + opts.bodyFont;
          ctx.fillText('Muñequera ' + side + ' · ' + (back ? 'Trasera' : 'Frontal'), x + BAND_W / 2, y + bandH + 20);
        });
      });
      var footY = H - FOOT_H + 18;
      if (logo) ctx.drawImage(logo, M_, footY, 40 * logo.naturalWidth / logo.naturalHeight, 40);
      ctx.fillStyle = '#5C5752';
      ctx.textAlign = 'right';
      ctx.font = '13px ' + opts.bodyFont;
      ctx.fillText('Vista previa · corexsport.com', W - M_, footY + 26);
      return TC.canvasToBlob(canvas, 'image/jpeg', 0.92);
    });
  }

  /* Sube los archivos y añade al carrito.
     opts: { design, lines: [{ variantId, quantity, model }], getImage, ensureReady, review, headFont, bodyFont, onProgress(text) }
     review: texto de la property «Revisión» (model.reviewNote). */
  function addDesignToCart(opts) {
    var d = opts.design;
    var jobs = M.printJobs(d);
    if (!jobs.length) return Promise.reject(userError('Añade al menos una imagen, un texto o un color de fondo.'));
    var group = M.groupId(Date.now(), Math.random().toString(36).slice(2, 8));
    var total = jobs.length + opts.lines.length, done = 0;
    var step = function () { opts.onProgress('Subiendo archivos… (' + Math.min(done + 1, total) + '/' + total + ')'); };
    var urls = {};
    opts.onProgress('Preparando archivos…');
    /* PNG a Blob: cada uno se genera justo antes de subirlo (no se acumulan lienzos grandes). */
    var blobJobs = jobs.map(function (j) {
      var ref = group + '/' + group + '_' + j.slug + '.png';
      return {
        key: j.faceKey, label: 'Muñequera ' + j.slug, name: j.slug + '.png',
        blob: { pathname: 'textil/pendiente/' + ref, contentType: 'image/png', link: KPI_BASE + '/api/textil-archivo?p=' + ref },
        make: function () {
          var canvas = D.renderPrint(d.faces[j.faceKey], opts.getImage);
          return TC.printPng(canvas).then(function (png) { canvas.width = 0; canvas.height = 0; return png; });
        }
      };
    });
    var chain = Promise.resolve(opts.ensureReady()).then(function () {
      return TC.uploadAll(null, group, blobJobs, function (i) { done = i; step(); });
    }).then(function (u) { Object.assign(urls, u); done = jobs.length; });
    var items = [];
    opts.lines.forEach(function (line) {
      chain = chain.then(function () {
        return previewJpg({ design: d, model: line.model, getImage: opts.getImage, headFont: opts.headFont, bodyFont: opts.bodyFont });
      }).then(function (jpg) {
        step();
        var slug = opts.lines.length > 1 ? PREVIEW_SLUG + '-' + line.model.key : PREVIEW_SLUG;
        return upload({ blob: jpg, name: slug + '.jpg', publicId: group + '_' + slug, label: 'Vista previa' }, group);
      }).then(function (preview) {
        done++;
        items.push({ id: line.variantId, quantity: line.quantity, properties: M.cartProperties(d, urls, preview, group, opts.review) });
      });
    });
    return chain.then(function () {
      opts.onProgress('Añadiendo…');
      return TC.addToCart(items);
    }).then(function () { return TC.refreshThemeCart(); });
  }

  global.CorexMunequeraCart = { previewJpg: previewJpg, addDesignToCart: addDesignToCart, loadImage: loadImage };
})(this);
